import { render } from "./aTable.vue?vue&type=template&id=f5f1525a&ts=true"
import script from "./aTable.vue?vue&type=script&lang=ts"
export * from "./aTable.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__